import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../../layouts/MainLayout';
import LeaveForm from '../../../components/hr/leaves/LeaveForm';
import { Card, Button, Space, message } from 'antd';
import { ArrowRightOutlined, UserOutlined } from '@ant-design/icons';
import { leavesApi, show422Error, ValidationError } from '../../../utils/api';

const AddLeave = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSave = async (payload) => {
    setLoading(true);
    try {
      await leavesApi.create(payload);
      message.success('مرخصی با موفقیت ثبت شد');
      navigate('/hr/leaves');
    } catch (error) {
      console.error('خطا در ذخیره مرخصی:', error);
      if (error instanceof ValidationError || (error.error && error.error.details)) {
        throw error;
      }
      message.error(error?.message || 'خطا در ثبت مرخصی');
    } finally {
      setLoading(false);
    }
  };

  return (
    <MainLayout>
      <div className="" style={{ fontFamily: 'CustomFont' }}>
        <Card className="shadow-xl border-0" bodyStyle={{ padding: 0 }}>
          <div className="flex items-center justify-between flex-wrap gap-4 p-6 border-b border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 rounded-t-xl">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-xl bg-blue-50 dark:bg-blue-900/20 flex items-center justify-center">
                <UserOutlined className="text-blue-600 dark:text-blue-400 text-xl" />
              </div>
              <div>
                <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-100 m-0">افزودن مرخصی</h1>
                <p className="text-gray-500 dark:text-gray-400 text-sm m-0">ثبت درخواست مرخصی جدید</p>
              </div>
            </div>
            <Space>
              <Button icon={<ArrowRightOutlined />} onClick={() => navigate('/hr/leaves')} style={{ fontFamily: 'CustomFont' }}>
                بازگشت
              </Button>
            </Space>
          </div>

          <div className="p-6 bg-gray-50 dark:bg-gray-900/50 rounded-b-xl">
            <Card className="shadow-sm border border-gray-100 dark:border-gray-700 bg-white dark:bg-gray-800">
              <LeaveForm
                onSave={handleSave}
                onCancel={() => navigate('/hr/leaves')}
                loading={loading}
              />
            </Card>
          </div>
        </Card>
      </div>
    </MainLayout>
  );
};

export default AddLeave;
